import onRequestUpdate from './onRequestUpdate'

const onClear = (key, room) => {
  // CarrierWaveの仕様でremoev_xxx(boolean型)なパラメータをリクエストに送るとDBとファイルを削除してくれる
  onRequestUpdate(room.set(`remove_${key}_url`, true))
}

export default onClear
